module.exports = __webpack_public_path__ + "img/frontend_base_industria.bb15196e.jpg";